import type { ContentBlock } from './sessionModel.ts'

export interface SubagentRetryProgress {
  tool_use_id?: string
  heartbeat?: boolean
  subagent_retry?: {
    attempt: number
    max_retries: number
    retry_delay_ms: number
    error_status?: number | null
  }
}

/** Apply the SDK's transient backoff state to the matching Agent tool block. */
export function applySubagentRetryProgress(
  blocks: ContentBlock[],
  progress: SubagentRetryProgress,
  now = Date.now(),
): ContentBlock[] {
  if (!progress.tool_use_id) return blocks
  const index = blocks.findIndex(
    (block) => block.type === 'tool_use' && block.name === 'Agent' && block.id === progress.tool_use_id,
  )
  if (index === -1) return blocks

  const block = blocks[index]
  if (block.type !== 'tool_use' || block.name !== 'Agent') return blocks
  const retry = progress.subagent_retry
  if (!retry && (progress.heartbeat || !block.retry)) return blocks
  const nextBlocks = [...blocks]
  nextBlocks[index] = {
    ...block,
    retry: retry
      ? {
        attempt: retry.attempt,
        maxRetries: retry.max_retries,
        retryDelayMs: retry.retry_delay_ms,
        retryAt: block.retry?.attempt === retry.attempt
          ? block.retry.retryAt
          : now + retry.retry_delay_ms,
        errorStatus: retry.error_status ?? undefined,
      }
      : undefined,
  }
  return nextBlocks
}
